import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { resetAll } from "../actions/filters";

class ResetButton extends React.Component {
  render() {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <a className="btn btn-default btn-block" onClick={this.props.onClick}>Reset</a>
      </div>
    );
  }
}

ResetButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => ({
  onClick: (e) => {
    e.preventDefault();
    e.stopPropagation();

    dispatch(resetAll({}));
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(ResetButton);
